import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getChangeEvent } from 'components/modules/Insurance/Insurance.helpers';
import * as CarInstanceActions from 'store/carInstance/actions';
import * as CarInstanceConstants from 'store/carInstance/constants';
import * as CarInstanceSelectors from 'store/carInstance/selectors';
import * as InsuranceActions from 'store/insurance/actions';
import * as InsuranceConstants from 'store/insurance/constants';
import * as InsuranceSelectors from 'store/insurance/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

export const usePtsInformationPresenter = () => {
  const dispatch = useDispatch();

  const {
    [CarInstanceConstants.PTS_VALUE_FIELDS.ISSUE_DATE]: issueDateError,
    [CarInstanceConstants.PTS_VALUE_FIELDS.NUMBER]: numberError,
  } =
    useSelector(CarInstanceSelectors.selectNestedErrors(CarInstanceConstants.VALUE_FIELDS.PTS)) ??
    {};
  const {
    [CarInstanceConstants.PTS_VALUE_FIELDS.ISSUE_DATE]: issueDate,
    [CarInstanceConstants.PTS_VALUE_FIELDS.NUMBER]: number,
  } = useSelector(CarInstanceSelectors.selectNestedValues(CarInstanceConstants.VALUE_FIELDS.PTS));
  const {
    [InsuranceConstants.DATA_VALUE_FIELDS.ERROR]: markAsPTSError,
    [InsuranceConstants.DATA_VALUE_FIELDS.VALUE]: markAsPTS,
  } = useSelector(InsuranceSelectors.selectDataField(InsuranceConstants.DATA_FIELDS.MARK_AS_PTS));
  const {
    [InsuranceConstants.DATA_VALUE_FIELDS.ERROR]: modelAsPTSError,
    [InsuranceConstants.DATA_VALUE_FIELDS.VALUE]: modelAsPTS,
  } = useSelector(InsuranceSelectors.selectDataField(InsuranceConstants.DATA_FIELDS.MODEL_AS_PTS));

  const { disabled: pageRestrict } = useDisabledFields();

  const onChangeCarInstanceValue = useCallback((event) => {
    const { key, value } = getChangeEvent(event);

    dispatch(
      CarInstanceActions.updateNestedErrors({
        errors: { [key]: '' },
        field: CarInstanceConstants.VALUE_FIELDS.PTS,
      })
    );
    dispatch(
      CarInstanceActions.updateNestedValues({
        field: CarInstanceConstants.VALUE_FIELDS.PTS,
        values: { [key]: value },
      })
    );
  }, []);
  const onChangeInsuranceValue = useCallback(({ key, value }) => {
    dispatch(
      InsuranceActions.updateDataFields({
        [key]: {
          [InsuranceConstants.DATA_VALUE_FIELDS.ERROR]: '',
          [InsuranceConstants.DATA_VALUE_FIELDS.VALUE]: value,
        },
      })
    );
  }, []);
  const onChangeMarkAsPTS = useCallback(
    (event) => {
      const { value } = getChangeEvent(event);

      onChangeInsuranceValue({ key: InsuranceConstants.DATA_FIELDS.MARK_AS_PTS, value });
    },
    [onChangeInsuranceValue]
  );
  const onChangeModelAsPTS = useCallback(
    (event) => {
      const { value } = getChangeEvent(event);

      onChangeInsuranceValue({ key: InsuranceConstants.DATA_FIELDS.MODEL_AS_PTS, value });
    },
    [onChangeInsuranceValue]
  );

  return {
    disabled: pageRestrict,
    issueDate,
    issueDateError,
    markAsPTS,
    markAsPTSError,
    modelAsPTS,
    modelAsPTSError,
    number,
    numberError,
    onChangeCarInstanceValue,
    onChangeMarkAsPTS,
    onChangeModelAsPTS,
  };
};
